import create from 'zustand'

export const useStore = create((set, get) => ({
  workers: [],
  ships: [],
  marketWorkers: [],
  marketSpaceships: [],
  displayDataShips: [],
  displayDataWorkers: [],
  filteredMarketSpaceships: [],
  updateWorkers: (item) => set(state => ({ workers: [...state.workers, item] })),
  changeShips: (item) => set(state => ({ ships: [...state.workers, item] })),
  changeMarketWorkers: (item) => set(state => ({ marketWorkers: [...state.workers, item] })),
  updateMarketSpaceships: (items) => set(() => ({ marketSpaceships: items })),
  updateFilteredMarketSpaceships: (items) => set(() => ({ filteredMarketSpaceships: items })),
  updateMarketWorkers: (items) => set(() => ({ marketWorkers: items })),
  updateDisplayDataShips: (items) => set(() => ({ displayDataShips: items })),
  updateDisplayDataWorkers: (items) => set(() => ({ displayDataWorkers: items })),
}))
